// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"bb722107","445":"72fe5d4d","453":"5b51b540"}[chunkId] + ".chunk.js";
};